var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1682_2201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8944 8.81641H22.3921L20.7569 28.465C20.7075 29.0545 20.2057 29.5162 19.6138 29.5162H5.83587C5.24401 29.5162 4.74217 29.0545 4.69277 28.465L3.05757 8.81641H1.55469L3.2006 28.5889C3.31385 29.9488 4.47142 31.0136 5.83587 31.0136H19.6137C20.9781 31.0136 22.1357 29.9488 22.2489 28.5889L23.4009 14.7487L23.8944 8.81641Z",
    fill: "#FF725E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4666 3.73496H17.5549C17.0678 1.57273 15.1428 0 12.8799 0H12.5714C10.308 0 8.38344 1.57273 7.89649 3.73496H0.984626C0.440765 3.73496 0 4.17586 0 4.71958V6.90045C0 7.44376 0.440904 7.88466 0.984626 7.88466H24.4665C25.0104 7.88466 25.4511 7.44376 25.4511 6.90003V4.71917C25.4511 4.17586 25.0102 3.73496 24.4665 3.73496H24.4666ZM9.44918 3.73496C9.89329 2.42087 11.1334 1.49718 12.5714 1.49718H12.8799C14.3179 1.49718 15.558 2.42129 16.0017 3.73496H9.44918Z",
    fill: "#FF725E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3922 27.2384L6.98684 10.373H5.48438L6.88973 27.2384H8.3922Z",
    fill: "#FF725E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.565 27.2384L19.9705 10.373H18.468L17.0625 27.2384H18.565Z",
    fill: "#FF725E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.474 10.373H11.9766V27.2384H13.474V10.373Z",
    fill: "#FF725E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5761 31.9998C27.0407 31.9998 30.66 28.3805 30.66 23.9159C30.66 19.4513 27.0407 15.832 22.5761 15.832C18.1115 15.832 14.4922 19.4513 14.4922 23.9159C14.4922 28.3805 18.1115 31.9998 22.5761 31.9998Z",
    fill: "#FF725E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2387 20.652L21.5356 24.6044C21.5781 25.1708 22.0336 25.6078 22.5818 25.6078C23.13 25.6078 23.585 25.1708 23.6275 24.6044L23.9244 20.652C23.9854 19.8402 23.3667 19.1465 22.5817 19.1465C21.7967 19.1465 21.1776 19.8401 21.2385 20.652H21.2387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.873 27.9202C23.873 27.2151 23.3458 26.6777 22.5845 26.6777C21.8232 26.6777 21.2969 27.2151 21.2969 27.9202C21.2969 28.6253 21.8238 29.1833 22.5845 29.1833C23.3453 29.1833 23.873 28.6151 23.873 27.9202Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1682_2201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.6631,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.d7d49733de2198ba04c81ac5f90bbb2a.svg";
export { ForwardRef as ReactComponent };